import { message } from 'antd'
import { Middleware } from '@reduxjs/toolkit'

const handleError = (error: any) => {
  let errorMessage = 'Xəta!'

  if (error?.name === 'ConditionError') {
    return
  }

  if (error?.data) {
    errorMessage = error.data
  } else if (error?.message) {
    errorMessage = error.message
  } else if (error?.response?.data) {
    errorMessage = error.response.data
  }

  message.error({
    maxCount: 2,
    duration: 5,
    content: errorMessage,
    style: { color: '#ff4d4f' },
  })
}

export const globalErrorMiddleware: Middleware =
  (storeAPI) => (next) => (action) => {
    if (action.type.endsWith('rejected') && !action.meta?.baseQueryMeta?.skipGlobalError) {
      const error = action.payload || action.error
      handleError(error)
    }
    return next(action)
  }
